const GROUP_KEYWORDS = {
  FRUITS: ["fruit", "fruta", "frutas"],
  VEGETABLES: ["vegetable", "vegetal", "vegetais", "verdura", "verduras"],
  MEATS: ["meat", "carne", "carnes", "frango", "peixe", "fish", "poultry"],
  DAIRY: ["dairy", "latic", "leite", "milk", "queijo", "cheese", "iogurte"],
  GRAINS: ["grain", "grão", "graos", "grãos", "cereal", "arroz", "rice", "pão", "bread"],
  LEGUMES: ["legume", "leguminosa", "feijão", "bean"],
  OILS: ["oil", "óleo", "oleo", "gordura"],
  SWEETS: ["sweet", "doce", "doces", "snack", "snacks", "biscoito", "cookie", "chocolate"],
  WATER: ["water", "água", "agua"],
  BEVERAGES: ["beverage", "bebida", "bebidas", "drink", "suco", "juice", "refrigerante"],
};

const UNIT_MAP = {
  units: "UNITS",
  unit: "UNITS",
  unidades: "UNITS",
  grams: "GRAMS",
  gram: "GRAMS",
  gramas: "GRAMS",
  g: "GRAMS",
  kilograms: "KILOGRAMS",
  kilogram: "KILOGRAMS",
  quilogramas: "KILOGRAMS",
  kg: "KILOGRAMS",
  liters: "LITERS",
  liter: "LITERS",
  litros: "LITERS",
  l: "LITERS",
  milliliters: "MILLILITERS",
  milliliter: "MILLILITERS",
  mililitros: "MILLILITERS",
  ml: "MILLILITERS",
};

export const getPhotoFromResponse = (response) => {
  const photo = response?.photo_response ?? response?.PhotoResponse;
  if (!photo?.id) {
    return null;
  }
  return {
    id: photo.id,
    url: photo.url ?? photo.photo_url,
  };
};

export const normalizeGroup = (aiGroup) => {
  if (!aiGroup) {
    return "OTHERS";
  }

  const normalized = aiGroup.trim().toUpperCase().replace(/\s+/g, "_");
  const validGroups = Object.keys(GROUP_KEYWORDS);
  if (validGroups.includes(normalized)) {
    return normalized;
  }

  const lower = aiGroup.toLowerCase();
  for (const [group, keywords] of Object.entries(GROUP_KEYWORDS)) {
    if (keywords.some((keyword) => lower.includes(keyword))) {
      return group;
    }
  }

  return "OTHERS";
};

export const normalizeUnit = (aiUnit) => {
  if (!aiUnit) {
    return null;
  }

  const key = aiUnit.trim().toLowerCase();
  return UNIT_MAP[key] ?? null;
};

const toFormValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  return String(value);
};

export const mapNutritionalTableToFormState = (response) => {
  if (!response) {
    return null;
  }

  const hasData = response.name
    || response.foodstuff_group
    || response.calories
    || response.brand
    || response.barcode;

  if (!hasData) {
    return null;
  }

  return {
    foodstuff: {
      name: response.name ?? "",
      group: normalizeGroup(response.foodstuff_group),
      unit_of_measurement: normalizeUnit(response.measurementmethod) ?? "",
      baseline_weight: toFormValue(response.base_weight),
      barcode: response.barcode ?? "",
    },
    nutritionInformation: {
      calories: toFormValue(response.calories),
      proteins: toFormValue(response.proteins),
      carbohydrates: toFormValue(response.carbohydrates),
      sodium: toFormValue(response.sodium),
      fiber: toFormValue(response.fiber),
      fats: toFormValue(response.total_fats),
    },
    selectedPhoto: getPhotoFromResponse(response),
    brandName: response.brand ?? null,
  };
};
